import { FeatureGeometry } from './Geoserver';
import User from './User';
import Task from './Task';
import { Adjuntos } from './Adjuntos';

export interface Geometry {
  id: number;
  titulo: string;
  descripcion?: string;
  color: string;
  tipo: 'punto' | 'poligono' | 'linea';
  fechaCreacion: number;
  createdBy: string;
  adjuntos?: Adjuntos[];
  atributos?: Atributos;
  usuario?: User;
}

export interface Point extends Geometry {
  latitud: number;
  longitud: number;
  categoria?: number | undefined;
  numeroActa?: string | undefined;
  numExp?: string | undefined;
}
export interface LatLong {
  latitud: number;
  longitud: number;
}

export interface Line extends Geometry {
  puntos: LatLong[];
  distancia? : string | undefined;
}

export interface Polygon extends Geometry {
  puntos: LatLong[];
  perimetro: string;
  area: string;
}

export const PointColors = [
  '#006854',
  '#B2D235',
  '#48C2C4',
  '#0078A0',
  '#DCDCDC',
  '#F03C5A',
  '#EA5050',
  '#BEA6F6',
  '#F3943E',
];

export interface MapLayer {
  title: string;
  name: string;
  bounds: number[];
  type: string;
  timeAttribute?: string;
}

export interface Atributos {
  style: {color: string};
  area? : string;
  perimetro?: string;
  distancia?: string;
  gps?: {latitud: string, longitud: string};
  gaussKruger?: {coords: number[], epsgCode: string, faja: number};
}

export interface ApiGeometry {
  id: number,
  titulo: string;
  tareaId: number;
  tipo: number;
  geometria: FeatureGeometry;
  atributos: Atributos | any;
  categoria?: number;
  numeroActa?: string;
  numExp?: string;
  descripcion?: string;
  usuarioId: string;
  usuario: User;
  createdAt: string;
  tarea?: Task;
  updatedAt?: string;
  adjuntos?: Adjuntos[];
}

export enum ApiGeometryType {
  USER_DRAWN = 1,
  CM = 2,
  INSPECTOR_DRAWN = 3,
  AOI = 4,
}

export interface AOI {
  id?: number;
  area: FeatureGeometry,
  layers: MapLayer[];
  bounds: number[];
  createdAt: number;
  adjunto?: Adjuntos;
}
